(ns common.schema.data-types
  (:require
    [clojure.edn :as edn]
    [clojure.set :as set]
    [common.schema.field-type :as field-type]))

(defn is-of-type
  [dt value bigdec?]
  (case dt
    :data.type/boolean (boolean? value)
    :data.type/currency-symbol (keyword? value)
    :data.type/currency-value (or (number? value)
                                  (bigdec? value))
    :data.type/date (number? value)
    :data.type/datetime (number? value)
    :data.type/email-multi (coll? value)
    :data.type/email (string? value)
    :data.type/text (string? value)
    :data.type/id (integer? value)
    :data.type/integer (integer? value)
    :data.type/keyword-multi (and (coll? value)
                                  (->> value
                                       (remove keyword?)
                                       (empty?)))
    :data.type/keyword (keyword? value)
    :data.type/long (integer? value)
    :data.type/number (number? value)
    :data.type/percentage (number? value)
    :data.type/multiplier (number? value)
    :data.type/ref-multi (and (coll? value)
                              (->> value
                                   (remove (fn [e]
                                             (or (:db/id e)
                                                 (integer? e))))
                                   (empty?)))
    :data.type/ref-single (or (:db/id value)
                              (integer? value))
    :data.type/text-edn (string? value)
    :data.type/financials (or (string? value)
                              (map? value))
    :data.type/tesi-financials (or (string? value)
                                   (map? value))
    :data.type/tesi-financials-2 (or (string? value)
                                     (map? value))
    :data.type/text-multiline (string? value)
    :data.type/text-multi (and (coll? value)
                               (->> value
                                    (remove string?)
                                    (empty?)))
    :data.type/url-multi (and (coll? value)
                              (->> value
                                   (remove string?)
                                   (empty?)))
    :data.type/text-richtext (string? value)
    :data.type/text-simple (string? value)
    :data.type/text-url (string? value)
    false))

(def creatable-types
  (->> field-type/field-types
       (vals)
       (map :data-type)
       (set)))

(def zapflow-data-types
  {:data.type/boolean           {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/boolean
                                 :serialization        :normal
                                 :default-editor       :editor.type/toggle
                                 :default-filter       :filter.type/boolean
                                 :allowed-editor-types #{:editor.type/toggle :editor.type/select :editor.type/checkbox}
                                 :allowed-filter-types #{:filter.type/select :filter.type/boolean}
                                 :number-id            1
                                 :bulk-editable?       true
                                 :translations         {:en "Boolean"}}
   :data.type/currency-symbol   {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/keyword
                                 :serialization        :normal
                                 :default-editor       :editor.type/select
                                 :default-filter       :filter.type/select
                                 :allowed-editor-types #{:editor.type/select}
                                 :allowed-filter-types #{:filter.type/select}
                                 :number-id            2
                                 :bulk-editable?       true
                                 :translations         {:en "Currency symbol"}}
   :data.type/currency-value    {:sort-type            :sort.type/currency-value
                                 :datomic/type         :db.type/bigdec
                                 :serialization        :normal
                                 :default-editor       :editor.type/number
                                 :default-filter       :filter.type/number
                                 :allowed-editor-types #{:editor.type/number :editor.type/currency-combo}
                                 :allowed-filter-types #{:filter.type/number}
                                 :number-id            3
                                 :bulk-editable?       true
                                 :translations         {:en "Currency"}}
   :data.type/datetime          {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/long
                                 :serialization        :normal
                                 :default-editor       :editor.type/datetime
                                 :default-filter       :filter.type/date
                                 :allowed-editor-types #{:editor.type/datetime :editor.type/date}
                                 :allowed-filter-types #{:filter.type/date}
                                 :number-id            4
                                 :bulk-editable?       false
                                 :translations         {:en "Date time"}}
   :data.type/date              {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/long
                                 :serialization        :normal
                                 :default-editor       :editor.type/date
                                 :default-filter       :filter.type/date
                                 :allowed-editor-types #{:editor.type/date}
                                 :allowed-filter-types #{:filter.type/date}
                                 :number-id            5
                                 :bulk-editable?       true
                                 :translations         {:en "Date"}}
   :data.type/date-year         {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/long
                                 :serialization        :normal
                                 :default-editor       :editor.type/integer
                                 :default-filter       :filter.type/integer
                                 :allowed-editor-types #{:editor.type/integer}
                                 :allowed-filter-types #{:filter.type/integer :filter.type/number}
                                 :number-id            6
                                 :bulk-editable?       true
                                 :translations         {:en "Year"}}
   :data.type/email-multi       {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/string
                                 :cardinality          :cardinality/many
                                 :serialization        :normal
                                 :default-editor       :editor.type/email
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/email-multi :editor.type/text-simple}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            7
                                 :bulk-editable?       true
                                 :translations         {:en "Email list"}}
   :data.type/email             {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/string
                                 :serialization        :normal
                                 :default-editor       :editor.type/email
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/email :editor.type/text-simple}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            8
                                 :bulk-editable?       true
                                 :translations         {:en "Email"}}
   :data.type/text              {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/string
                                 :serialization        :normal
                                 :default-editor       :editor.type/text-simple
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/text-simple :editor.type/textarea}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            9
                                 :bulk-editable?       true
                                 :translations         {:en "Text"}}
   :data.type/text-multi        {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/string
                                 :cardinality          :cardinality/many
                                 :serialization        :normal
                                 :default-editor       :editor.type/text-simple
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/text-simple :editor.type/textarea}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            10
                                 :bulk-editable?       true
                                 :translations         {:en "Text list"}}
   :data.type/url-multi         {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/string
                                 :cardinality          :cardinality/many
                                 :serialization        :normal
                                 :default-editor       :editor.type/text-simple
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/url :editor.type/url-multi :editor.type/text-simple :editor.type/textarea}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            11
                                 :bulk-editable?       true
                                 :translations         {:en "URL list"}}
   :data.type/id                {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/ref
                                 :serialization        :ref
                                 :create-type          :editor.type/select
                                 :default-editor       :editor.type/text-simple
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/select}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            12
                                 :bulk-editable?       false
                                 :translations         {:en "UUID"}}
   :data.type/integer           {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/long
                                 :coerce               (fn [a]
                                                         (when (number? a)
                                                           (long a)))
                                 :serialization        :normal
                                 :default-editor       :editor.type/integer
                                 :default-filter       :filter.type/integer
                                 :allowed-editor-types #{:editor.type/integer :editor.type/number}
                                 :allowed-filter-types #{:filter.type/number}
                                 :number-id            13
                                 :bulk-editable?       true
                                 :translations         {:en "Integer"}}
   :data.type/keyword-multi     {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/keyword
                                 :cardinality          :cardinality/many
                                 :serialization        :set-values
                                 :create-type          :editor.type/select
                                 :default-filter       :filter.type/select
                                 :allowed-editor-types #{:editor.type/select :editor.type/multi-select}
                                 :allowed-filter-types #{:filter.type/select :filter.type/text}
                                 :number-id            14
                                 :bulk-editable?       true
                                 :default-editor       :editor.type/multi-select
                                 :translations         {:en "Option list"}}
   :data.type/keyword           {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/keyword
                                 :serialization        :normal
                                 :create-type          :editor.type/select
                                 :default-editor       :editor.type/select
                                 :default-filter       :filter.type/select
                                 :allowed-editor-types #{:editor.type/select}
                                 :allowed-filter-types #{:filter.type/select :filter.type/text}
                                 :number-id            15
                                 :bulk-editable?       true
                                 :translations         {:en "Option"}}
   :data.type/long              {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/long
                                 :coerce               (fn [a]
                                                         (when (number? a)
                                                           (long a)))
                                 :serialization        :normal
                                 :default-editor       :editor.type/integer
                                 :default-filter       :filter.type/integer
                                 :allowed-editor-types #{:editor.type/integer :editor.type/number}
                                 :allowed-filter-types #{:filter.type/number}
                                 :number-id            16
                                 :bulk-editable?       true
                                 :translations         {:en "Integer"}}
   :data.type/number            {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/double
                                 :coerce               (fn [a]
                                                         (when (number? a)
                                                           (double a)))
                                 :serialization        :normal
                                 :default-editor       :editor.type/number
                                 :default-filter       :filter.type/number
                                 :allowed-editor-types #{:editor.type/number}
                                 :allowed-filter-types #{:filter.type/number}
                                 :number-id            17
                                 :bulk-editable?       true
                                 :translations         {:en "Decimal"}}
   :data.type/percentage        {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/double
                                 :serialization        :normal
                                 :default-editor       :editor.type/percentage
                                 :default-filter       :filter.type/percentage
                                 :allowed-editor-types #{:editor.type/percentage :editor.type/number}
                                 :allowed-filter-types #{:filter.type/number}
                                 :number-id            18
                                 :bulk-editable?       true
                                 :translations         {:en "Percentage"}}
   :data.type/multiplier        {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/double
                                 :serialization        :normal
                                 :default-editor       :editor.type/multiplier
                                 :default-filter       :filter.type/multiplier
                                 :allowed-editor-types #{:editor.type/multiplier :editor.type/number}
                                 :allowed-filter-types #{:filter.type/number}
                                 :number-id            19
                                 :bulk-editable?       true
                                 :translations         {:en "Multiplier"}}
   :data.type/ref-multi         {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/ref
                                 :cardinality          :cardinality/many
                                 :serialization        :set-ref
                                 :create-type          :editor.type/select
                                 :default-editor       :editor.type/multi-select
                                 :default-filter       :filter.type/select
                                 :allowed-editor-types #{:editor.type/select :editor.type/multi-select}
                                 :allowed-filter-types #{:filter.type/select :filter.type/text}
                                 :number-id            20
                                 :bulk-editable?       true
                                 :translations         {:en "Reference list"}}
   :data.type/ref-single        {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/ref
                                 :serialization        :ref
                                 :create-type          :editor.type/select
                                 :default-editor       :editor.type/select
                                 :default-filter       :filter.type/select
                                 :allowed-editor-types #{:editor.type/select}
                                 :allowed-filter-types #{:filter.type/select :filter.type/text}
                                 :number-id            21
                                 :bulk-editable?       true
                                 :translations         {:en "Reference"}}
   :data.type/text-edn          {:sort-type               :sort.type/display-string
                                 :datomic/type            :db.type/string
                                 :common/content-encoding :common.content-encoding/edn
                                 :serialization           :map
                                 :default-editor          :editor.type/none
                                 :default-filter          :filter.type/none
                                 :allowed-editor-types    #{}
                                 :allowed-filter-types    #{:filter.type/text}
                                 :number-id               22
                                 :bulk-editable?          false
                                 :translations            {:en "Complex data"}}
   :data.type/financials        {:sort-type               :sort.type/display-string
                                 :datomic/type            :db.type/string
                                 :common/content-encoding :common.content-encoding/edn
                                 :serialization           :map
                                 :default-editor          :editor.type/financials
                                 :default-filter          :filter.type/none
                                 :allowed-editor-types    #{:editor.type/financials}
                                 :allowed-filter-types    #{}
                                 :number-id               23
                                 :bulk-editable?          false
                                 :translations            {:en "Complex data"}}
   :data.type/tesi-financials   {:sort-type               :sort.type/display-string
                                 :datomic/type            :db.type/string
                                 :common/content-encoding :common.content-encoding/edn
                                 :serialization           :map
                                 :default-editor          :editor.type/tesi-financials
                                 :default-filter          :filter.type/none
                                 :allowed-editor-types    #{:editor.type/tesi-financials}
                                 :allowed-filter-types    #{}
                                 :number-id               24
                                 :bulk-editable?          false
                                 :translations            {:en "Complex data"}}
   :data.type/tesi-financials-2 {:sort-type               :sort.type/display-string
                                 :datomic/type            :db.type/string
                                 :common/content-encoding :common.content-encoding/edn
                                 :serialization           :map
                                 :default-editor          :editor.type/tesi-financials-2
                                 :default-filter          :filter.type/none
                                 :allowed-editor-types    #{:editor.type/tesi-financials-2}
                                 :allowed-filter-types    #{}
                                 :number-id               25
                                 :bulk-editable?          false
                                 :translations            {:en "Complex data"}}
   :data.type/text-multiline    {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/string
                                 :serialization        :normal
                                 :default-editor       :editor.type/textarea
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/textarea :editor.type/text-simple}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            26
                                 :bulk-editable?       true
                                 :translations         {:en "Text long"}}
   :data.type/text-richtext     {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/string
                                 :serialization        :sanitize-html
                                 :default-editor       :editor.type/wysiwyg
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/wysiwyg
                                                         :editor.type/textarea
                                                         :editor.type/richtext-mention}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            27
                                 :bulk-editable?       true
                                 :translations         {:en "Text formatted"}}
   :data.type/text-simple       {:sort-type            :sort.type/display-string
                                 :datomic/type         :db.type/string
                                 :serialization        :normal
                                 :default-editor       :editor.type/text-simple
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/text-simple
                                                         :editor.type/textarea
                                                         :editor.type/text-mention}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            28
                                 :bulk-editable?       true
                                 :translations         {:en "Text short"}}
   :data.type/text-url          {:sort-type            :sort.type/native-value
                                 :datomic/type         :db.type/string
                                 :serialization        :sanitize-url
                                 :default-editor       :editor.type/url
                                 :default-filter       :filter.type/text
                                 :allowed-editor-types #{:editor.type/url :editor.type/text-simple}
                                 :allowed-filter-types #{:filter.type/text}
                                 :number-id            29
                                 :bulk-editable?       true
                                 :translations         {:en "URL"}}
   :data.type/file              {:sort-type      :sort.type/display-string
                                 :datomic/type   :db.type/ref
                                 :default-editor :editor.type/file-simple
                                 :default-filter :filter.type/known
                                 :allowed-editor-types #{:editor.type/file-simple}
                                 :allowed-filter-types #{:filter.type/known}
                                 :number-id      30
                                 :bulk-editable? false
                                 :translations   {:en "File"}}})

(def data-type-keywords
  (keys zapflow-data-types))

(def data-type-by-number-id
  (->> zapflow-data-types
       (map (fn [[dt info]]
              [(:number-id info) dt]))
       (into {})))

(def number-id-by-data-type
  (->> zapflow-data-types
       (map (fn [[dt info]]
              [dt (:number-id info)]))
       (into {})))

(defn to-keyword-data-type
  [data-type]
  (cond (keyword? data-type)
        (some #{data-type} data-type-keywords)
        (number? data-type)
        (get data-type-by-number-id data-type)
        (string? data-type)
        (edn/read-string data-type)))

(def multi-data-types
  (->> zapflow-data-types
       (keep (fn [[k field-info]]
               (when (some->> field-info
                              :cardinality
                              (= :cardinality/many))
                 k)))
       (set)))

(def numeric-data-types
  (->> zapflow-data-types
       (filter (fn [[_dt m]]
                 (some #{(:datomic/type m)} [:db.type/long :db.type/double :db.type/bigdec :db.type/bigint])))
       (map key)
       (set)))

(def date-data-types #{:data.type/date :data.type/datetime})

(def ref-types
  #{:data.type/ref-single
    :data.type/ref-multi})

(defn ref-type?
  [data-type]
  (get ref-types data-type))

(def kw-types
  #{:data.type/keyword
    :data.type/keyword-multi})

(defn kw-type?
  [data-type]
  (contains? kw-types data-type))

(def ref-or-kw-types
  (set/union ref-types
             kw-types))

(def multi-types #{:data.type/keyword-multi
                   :data.type/ref-multi
                   :data.type/email-multi
                   :data.type/text-multi
                   :data.type/url-multi})

(def options
  (->> zapflow-data-types
       (map (fn [[k info]]
              {:key   k
               :label (->> info
                           :translations
                           :en)}))
       (doall)))

;; TODO: clean this up when webforms are rewritten
(defn to-webform-type
  [dt]
  (case dt
    :data.type/boolean "switch"
    :data.type/currency-value "currency--sym"
    :data.type/datetime "date-ms"
    :data.type/date "date"
    :data.type/email-multi "email"
    :data.type/email "email"
    :data.type/financials "financials"
    :data.type/tesi-financials "tesi-financials"
    :data.type/tesi-financials-2 "tesi-financials-2"
    :data.type/text "text"
    :data.type/integer "integer"
    :data.type/keyword-multi "multi-select"
    :data.type/keyword "select"
    :data.type/long "integer"
    :data.type/number "numeric"
    :data.type/percentage "percentage"
    :data.type/multiplier "multiplier"
    :data.type/ref-multi "multi-select"
    :data.type/ref-single "select"
    :data.type/text-edn "textarea"
    :data.type/text-multiline "textarea"
    :data.type/text-richtext "textarea"
    :data.type/text-simple "text"
    :data.type/text-url "url"
    :data.type/file "file"
    :data.type/id nil))

(defn multi-data-type?
  [data-type]
  (contains? multi-data-types data-type))

(def data-types-spec
  [;; ---------------------------------------------------------------------------
   {:data-type               :data.type/boolean
    :bulk-editable?          true
    :default-editor          :editor.type/toggle
    :allowed-editor-types    #{:editor.type/toggle}
    :default-filter          :filter.type/boolean
    :allowed-filter-types    #{:filter.type/boolean}
    :i18n/name-key           :i18n.data-type/boolean
    :default-validation-spec :boolean}

   {:data-type               :data.type/currency-symbol
    :bulk-editable?          true
    :default-editor          :editor.type/select
    :allowed-editor-types    #{:editor.type/select}
    :default-filter          :filter.type/select
    :allowed-filter-types    #{:filter.type/select}
    :i18n/name-key           :i18n.data-type/currency-symbol
    :default-validation-spec :keyword}

   {:data-type               :data.type/currency-value
    :bulk-editable?          true
    :default-editor          :editor.type/number
    :allowed-editor-types    #{:editor.type/number}
    :default-filter          :filter.type/number
    :allowed-filter-types    #{:filter.type/number}
    :i18n/name-key           :i18n.data-type/currency-value
    :default-validation-spec :double}

   {:data-type               :data.type/datetime
    :bulk-editable?          false
    :default-editor          :editor.type/datetime
    :allowed-editor-types    #{:editor.type/datetime}
    :default-filter          :filter.type/date
    :allowed-filter-types    #{:filter.type/date}
    :i18n/name-key           :i18n.data-type/datetime
    :default-validation-spec :int}

   {:data-type               :data.type/date
    :bulk-editable?          true
    :default-editor          :editor.type/date
    :allowed-editor-types    #{:editor.type/date}
    :default-filter          :filter.type/date
    :allowed-filter-types    #{:filter.type/date}
    :i18n/name-key           :i18n.data-type/date
    :default-validation-spec :int}

   {:data-type               :data.type/date-year
    :bulk-editable?          true
    :default-editor          :editor.type/integer
    :allowed-editor-types    #{:editor.type/integer}
    :default-filter          :filter.type/integer
    :allowed-filter-types    #{:filter.type/integer}
    :i18n/name-key           :i18n.data-type/date-year
    :default-validation-spec :int}

   {:data-type               :data.type/email-multi
    :cardinality             :cardinality/many
    :bulk-editable?          true
    :default-editor          :editor.type/email
    :allowed-editor-types    #{:editor.type/email}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/email-multi
    :default-validation-spec [:sequential :string]}

   {:data-type               :data.type/email
    :bulk-editable?          true
    :default-editor          :editor.type/email
    :allowed-editor-types    #{:editor.type/email}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/email
    :default-validation-spec :string}

   {:data-type               :data.type/text
    :bulk-editable?          true
    :default-editor          :editor.type/text-simple
    :allowed-editor-types    #{:editor.type/text-simple}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/text
    :default-validation-spec :string}

   {:data-type               :data.type/text-multi
    :cardinality             :cardinality/many
    :bulk-editable?          true
    :default-editor          :editor.type/text-simple
    :allowed-editor-types    #{:editor.type/text-simple}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/text-multi
    :default-validation-spec [:sequential :string]}

   {:data-type               :data.type/url-multi
    :cardinality             :cardinality/many
    :bulk-editable?          true
    :default-editor          :editor.type/text-simple
    :allowed-editor-types    #{:editor.type/text-simple}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/url-multi
    :default-validation-spec [:sequential :string]}

   {:data-type               :data.type/id
    :bulk-editable?          false
    :default-editor          :editor.type/text-simple
    :allowed-editor-types    #{:editor.type/text-simple}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/id
    :default-validation-spec :int}

   {:data-type               :data.type/integer
    :bulk-editable?          true
    :default-editor          :editor.type/integer
    :allowed-editor-types    #{:editor.type/integer}
    :default-filter          :filter.type/integer
    :allowed-filter-types    #{:filter.type/integer}
    :i18n/name-key           :i18n.data-type/integer
    :default-validation-spec :int}

   {:data-type               :data.type/keyword-multi
    :cardinality             :cardinality/many
    :bulk-editable?          true
    :default-editor          :editor.type/multi-select
    :allowed-editor-types    #{:editor.type/multi-select}
    :default-filter          :filter.type/select
    :allowed-filter-types    #{:filter.type/select}
    :i18n/name-key           :i18n.data-type/keyword-multi
    :default-validation-spec [:sequential :keyword]}

   {:data-type               :data.type/keyword
    :bulk-editable?          true
    :default-editor          :editor.type/select
    :allowed-editor-types    #{:editor.type/select}
    :default-filter          :filter.type/select
    :allowed-filter-types    #{:filter.type/select}
    :i18n/name-key           :i18n.data-type/keyword
    :default-validation-spec :keyword}

   {:data-type               :data.type/long
    :bulk-editable?          true
    :default-editor          :editor.type/integer
    :allowed-editor-types    #{:editor.type/integer}
    :default-filter          :filter.type/integer
    :allowed-filter-types    #{:filter.type/integer}
    :i18n/name-key           :i18n.data-type/long
    :default-validation-spec :int}

   {:data-type               :data.type/number
    :bulk-editable?          true
    :default-editor          :editor.type/number
    :allowed-editor-types    #{:editor.type/number}
    :default-filter          :filter.type/number
    :allowed-filter-types    #{:filter.type/number}
    :i18n/name-key           :i18n.data-type/number
    :default-validation-spec :double}

   {:data-type               :data.type/percentage
    :bulk-editable?          true
    :default-editor          :editor.type/percentage
    :allowed-editor-types    #{:editor.type/percentage}
    :default-filter          :filter.type/percentage
    :allowed-filter-types    #{:filter.type/percentage}
    :i18n/name-key           :i18n.data-type/percentage
    :default-validation-spec :double}

   {:data-type               :data.type/multiplier
    :bulk-editable?          true
    :default-editor          :editor.type/multiplier
    :allowed-editor-types    #{:editor.type/multiplier}
    :default-filter          :filter.type/multiplier
    :allowed-filter-types    #{:filter.type/multiplier}
    :i18n/name-key           :i18n.data-type/multiplier
    :default-validation-spec :double}

   {:data-type               :data.type/ref-multi
    :cardinality             :cardinality/many
    :bulk-editable?          true
    :default-editor          :editor.type/multi-select
    :allowed-editor-types    #{:editor.type/multi-select}
    :default-filter          :filter.type/select
    :allowed-filter-types    #{:filter.type/select}
    :i18n/name-key           :i18n.data-type/ref-multi
    :default-validation-spec [:sequential [:map [:db/id pos-int?]]]}

   {:data-type               :data.type/ref-single
    :bulk-editable?          true
    :default-editor          :editor.type/select
    :allowed-editor-types    #{:editor.type/select}
    :default-filter          :filter.type/select
    :allowed-filter-types    #{:filter.type/select}
    :i18n/name-key           :i18n.data-type/ref-single
    :default-validation-spec [:map [:db/id pos-int?]]}

   {:data-type               :data.type/text-edn
    :bulk-editable?          false
    :default-editor          :editor.type/none
    :allowed-editor-types    #{:editor.type/none}
    :default-filter          :filter.type/none
    :allowed-filter-types    #{:filter.type/none}
    :i18n/name-key           :i18n.data-type/text-edn
    :default-validation-spec :string}

   {:data-type               :data.type/financials
    :bulk-editable?          false
    :default-editor          :editor.type/financials
    :allowed-editor-types    #{:editor.type/financials}
    :default-filter          :filter.type/none
    :allowed-filter-types    #{:filter.type/none}
    :i18n/name-key           :i18n.data-type/financials
    :default-validation-spec :string}

   {:data-type               :data.type/tesi-financials
    :bulk-editable?          false
    :default-editor          :editor.type/tesi-financials
    :allowed-editor-types    #{:editor.type/tesi-financials}
    :default-filter          :filter.type/none
    :allowed-filter-types    #{:filter.type/none}
    :i18n/name-key           :i18n.data-type/tesi-financials
    :default-validation-spec :string}

   {:data-type               :data.type/tesi-financials-2
    :bulk-editable?          false
    :default-editor          :editor.type/tesi-financials-2
    :allowed-editor-types    #{:editor.type/tesi-financials-2}
    :default-filter          :filter.type/none
    :allowed-filter-types    #{:filter.type/none}
    :i18n/name-key           :i18n.data-type/tesi-financials-2
    :default-validation-spec :string}

   {:data-type               :data.type/text-multiline
    :bulk-editable?          true
    :default-editor          :editor.type/textarea
    :allowed-editor-types    #{:editor.type/textarea}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/text-multiline
    :default-validation-spec :string}

   {:data-type               :data.type/text-richtext
    :bulk-editable?          true
    :default-editor          :editor.type/wysiwyg
    :allowed-editor-types    #{:editor.type/wysiwyg
                               :editor.type/richtext-mention}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/text-richtext
    :default-validation-spec :string}

   {:data-type               :data.type/text-simple
    :bulk-editable?          true
    :default-editor          :editor.type/text-simple
    :allowed-editor-types    #{:editor.type/text-simple
                               :editor.type/text-mention}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/text-simple
    :default-validation-spec :string}

   {:data-type               :data.type/text-url
    :bulk-editable?          true
    :default-editor          :editor.type/url
    :allowed-editor-types    #{:editor.type/url}
    :default-filter          :filter.type/text
    :allowed-filter-types    #{:filter.type/text}
    :i18n/name-key           :i18n.data-type/text-url
    :default-validation-spec :string}

   {:data-type               :data.type/file
    :bulk-editable?          false
    :default-editor          :editor.type/none
    :allowed-editor-types    #{:editor.type/none}
    :default-filter          :filter.type/known
    :allowed-filter-types    #{:filter.type/known}
    :i18n/name-key           :i18n.data-type/file
    :default-validation-spec [:map [:db/id pos-int?]]}])
